var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.data.deliveryWay === '3' && !_vm.data.advanceSale
    )?_c('div',{staticClass:"delivery"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.data.goodsLogistics.advanceTime)+"\n      ")])]):_vm._e(),_vm._v(" "),(
      _vm.data.deliveryWay === '1' && !_vm.data.advanceSale
    )?_c('div',{staticClass:"delivery"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.data.goodsLogistics.advanceTime)+"\n      ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }